import React from "react";
import axios from 'axios';
import { connect } from "react-redux";
import '../MoneyTransferComponent/TransactionList.css';
import FooterComponet from "../FooterComponent/FooterComponet";
import SubTransactionTxn from "../MoneyTransferComponent/SubTransactionTxn";
import moment from "moment";
import { CSVLink } from "react-csv";
import FinxPayLogo from "../../assests/images/finxpay.png";
import { v4 as uuidv4 } from 'uuid';
import Pagination from "react-js-pagination";
import { store } from "../../redux/store";
import { setTxnHistoryElementNo, setTxnHistoryResponse, setTxnReportingData, setTxnHistoryPaginationResponse } from '../../redux/misc-data/misc-data.action';
import { setFilterEndDate, setFilterStartDate, setRechargeType } from "../../redux/recharge/recharge.action";
import HeaderCommon from '../HeaderComponent/HeadeCommon';
import ContentLoader from 'react-content-loader';
import Menu from "../MenuComponent/Menu";
import { Link } from "react-router-dom";
// import Subtransaction from "./Subtransaction";
// import OrderDetails from "./OrderDetails";
// import TransferDetails from "./TransferDetails";
import tokenErrorHandler from "../tokenErrorHandler";
const httpClient = axios.create();


class PayoutAllTxn extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            phoneNo: this.props.phone,
            message: '',
            loading: false,
            txnData: '',
            showModal: false,
            surcharge: '',
            totalAmount: '',
            orderId: '',
            createdOn: '',
            paymentStatus: '',
            searchTxn: '',
            formDate: '',
            toDate: '',
            activePage: 1,
            statusList: [
                { value: "Select", label: "Select" },
                { value: "Success", label: "Success" },
                { value: "Failed", label: "Failed" },
                { value: "Pending", label: "Pending" },
                { value: "Processing", label: "Processing" }
            ],
            selectedStatus: '',
            applyFiler: false,
            errorMessage: '',
            enteredTxn: '',
            contentLoading: false,
            txnSubOrder: '',
            payoutHistory: 'loading',
            totalElements: 0,
            totalPages: 0,
            paymentStatus: '',
            transferredAmount: '',
            orderId: '',
            createdOn: '',

            benefisciaryMobile: '',
            benefisciaryName: '',
            mobile: '',
            customerId: '',
            benefisciaryName: '',


            paymentTxnId: '',
            createdOn: '',
        }
    }



    enterTxn = (event) => {
        event.preventDefault();
        this.setState({
            enteredTxn: event.target.value.toLowerCase()
        })
    }

    searchTxn = (event) => {

        event.preventDefault();
        if (this.state.enteredTxn.length > 0) {

            var txnSearchurl = '/api/v1/payout/order/search/' + this.state.enteredTxn.toLowerCase() + '/' + this.props.agentInfo.id;


            const headers = {
                'Authorization': 'Bearer ' + this.props.token,
                'client-id': this.props.agentInfo.id,
                'role': this.props.clientRole
            }

            this.setState({ activePage: 1 });

            httpClient.get(txnSearchurl, { headers }
            ).then((response) => {

                console.log('txn search response' + JSON.stringify(response.data));
                if (response.data.response.msg == 'SUCCESS') {
                    console.log('txn search success response....' + response.data);
                    this.setState({
                        payoutHistory: response.data.list,
                        totalElements: response.data.totalElements,
                        totalPages: response.data.totalPages
                    })


                } else {
                    this.errorMessageCall(response.data.response.displayMsg);
                    this.setState({
                        payoutHistory: [],
                        totalElements: response.data.totalElements,
                        totalPages: response.data.totalPages
                    })
                    console.log('txn search failure response....' + response.data);
                }
            }).catch(error => {

                if (error.message.includes("401")) {
                    tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
                } else {

                }
            });
        }




    }


    handlePageChangeDefault(pageNumber) {
        this.setState({
            activePage: pageNumber
        })


        console.log(pageNumber);

        this.loadTxnHistory(pageNumber - 1, this.props.formDate !== '' ? moment(this.props.formDate).format('YYYY-MM-DD') :
            '', this.props.toDate !== '' ? moment(this.props.toDate).format('YYYY-MM-DD') : '', this.state.selectedStatus);

    }



    moDalPrint = (event, txn) => {
        event.preventDefault();


        this.setState({
            showModal: true,
            paymentStatus: txn.status != null ? txn.status : 'Unknown Status',
            transferredAmount: txn.transaction != null ? txn.transaction.amount : 'NA',
            orderId: txn.id != null ? txn.id : 'Unlnown Id',
            createdOn: moment(txn.createdOn).format('DD-MM-YYYY hh:mm:ss'),

            benefisciaryMobile: txn.beneficiary.mobile,
            benefisciaryName: txn.beneficiary.name,
            mobile: txn.transaction.mobile,
            customerId: txn.transaction.customerId,
            benefisciaryName: txn.beneficiary.name,


            paymentTxnId: txn.txnDetails.paymentTxnId,
            createdOn: moment(txn.createdOn).format('DD-MM-YYYY HH:mm:ss')

        })
    }


    componentDidMount = () => {
        // this.handlePageChangeDefault(0);
        store.dispatch(setTxnHistoryElementNo(''));
        store.dispatch(setFilterEndDate(''));
        store.dispatch(setFilterStartDate(''));

        var startDate = moment().format('YYYY-MM-DD');



        var d = new Date();
        d.setDate(d.getDate() + 7);

        var endDate = d.toISOString().slice(0, 10);
        console.log('start date' + startDate);
        console.log('to date..' + endDate);

        var status = '';
        this.loadTxnHistory(0, '', '', status);
    }


    loadTxnHistory(pageNo, startDate, endDate, status) {
        var url = '';
        this.setState({
            errorMessage: '',
            contentLoading: true
        })


        url = '/api/v1/payout/order/history/' + this.props.agentInfo.id + '/' + startDate + '/' + endDate + '/' + pageNo;
        const headers = {
            'Authorization': 'Bearer ' + this.props.token,
            'client-id': this.props.agentInfo.id,
            'role': this.props.clientRole
        }

        httpClient.get(url, {
            timeout: 180 * 1000,
            timeoutErrorMessage: 'timeout',
            headers
        }
        ).then((response) => {

            this.setState({
                contentLoading: false
            })
            console.log(' response' + JSON.stringify(response.data));
            if (response.data.response.msg == 'SUCCESS') {

                this.setState({
                    payoutHistory: response.data.list,
                    totalElements: response.data.totalElements,
                    totalPages: response.data.totalPages
                })
                this.txnHistory();

            } else {
                this.setState({
                    contentLoading: false,
                    errorMessage: response.data.response.displayMsg
                })

            }
        }).catch(error => {
            this.setState({
                contentLoading: false,
                errorMessage: 'Something went wrong!'
            })

        })
    }

    applyTxnHistory() {
        var url = '';
        this.setState({
            errorMessage: '',
            contentLoading: true
        })
        url = '/api/v1/payout/order/history/' + this.props.agentInfo.id + '/' + moment(this.props.formDate).format('YYYY-MM-DD') + '/' + moment(this.props.toDate).format('YYYY-MM-DD') + '/' + 0;
        const headers = {
            'Authorization': 'Bearer ' + this.props.token,
            'client-id': this.props.agentInfo.id,
            'role': this.props.clientRole
        }

        httpClient.get(url, {
            timeout: 180 * 1000,
            timeoutErrorMessage: 'timeout',
            headers
        }
        ).then((response) => {
            this.setState({
                contentLoading: false
            })
            console.log(' response' + JSON.stringify(response.data));
            if (response.data.response.msg == 'SUCCESS') {

                this.setState({
                    payoutHistory: response.data.list,
                    totalElements: response.data.totalElements,
                    totalPages: response.data.totalPages,
                    activePage: 1
                })
                this.txnHistory();

            } else {
                this.setState({
                    contentLoading: false,
                    errorMessage: response.data.response.displayMsg
                })

            }
        }).catch(error => {
            this.setState({
                contentLoading: false,
                errorMessage: 'Something went wrong!'
            })

        })
    }





    txnHistory = () => {
        store.dispatch(setTxnReportingData(''));


        var OrderId = '';
        var OrderCreatedOn = '';
        var orderList = [];
        var orderList1 = [];
        var rowList = [];

        this.state.rechargeTxnHistory.map(res => {
            OrderId = res.id == null ? '' : res.id;
            OrderCreatedOn = res.createdOn == null ? '' : moment(res.createdOn).format('DD-MM-YYYY hh:mm:ss')
            var orderObj = {
                orderId: OrderId,
                orderCreatedOn: OrderCreatedOn,
                suborderObjList: []

            }
            if (!orderList.includes(orderObj)) {
                orderList.push(orderObj);
            }
        })
        // console.log('order List:'+JSON.stringify(orderList1));
        console.log('order List size:' + orderList.length);

        orderList.map(order => {

            console.log('order ..' + order.orderId);
            var row = {

                PaymentStatus: '',
                OrderId: '',
                OrderCreatedOn: '',

            }

            row.OrderId = order.orderId;
            row.OrderCreatedOn = order.orderCreatedOn;
            row.PaymentStatus = order.paymentStatus;
            if (!rowList.includes(row)) {
                rowList.push(row);
            }

        })

        console.log('rowList::' + JSON.stringify(rowList));


        store.dispatch(setTxnReportingData(rowList));




    }
    componentWillUnmount() {
    }





    statusSelect = (event) => {
        if (event.target.value == 'Select') {
            alert('Please select a  status');

        } else {
            this.setState({
                selectedStatus: event.target.value
            })
        }
    }


    formDateSelect = (event) => {
        console.log(event.target.value);
        store.dispatch(setFilterStartDate(event.target.value))
    }


    toDateSelect = (event) => {
        console.log(event.target.value);
        store.dispatch(setFilterEndDate(event.target.value))
    }


    resetExportDate = (event) => {
        setTimeout(() => {
            store.dispatch(setTxnReportingData(''));
        }, 200);
    }


    printdiv = (event) => {
        event.preventDefault();
        var divContents = document.getElementById("print").innerHTML;
        var a = window.open('', '', 'height=500, width=500');
        a.document.write('<html>');
        a.document.write('<body>');
        a.document.write(divContents);
        a.document.write('</body></html>');
        a.document.close();
        a.print();
    }

    clearAll = (event) => {
        this.setState({
            selectedStatus: '',
            activePage: 1,
            payoutHistory: 'loading'
        })

        store.dispatch(setFilterEndDate(''));
        store.dispatch(setFilterStartDate(''));

        var startDate = moment().format('YYYY-MM-DD');
        console.log('to date..' + startDate);
        var d = new Date();
        d.setDate(d.getDate() + 7);

        var endDate = d.toISOString().slice(0, 10);
        console.log('start date' + startDate);
        console.log('end date' + endDate);

        var status = '';
        this.loadTxnHistory(0, '', '', status);
    }


    submitFilter = (event) => {
        event.preventDefault();
        this.setState({
            applyFiler: 'true'
        });



        if (this.props.formDate == '' && this.props.toDate == '') {
            alert('Please enter start date and End date');
        } else {
            if (this.props.formDate == '') {
                alert('Please enter start date');
            }

            if (this.props.toDate == '') {
                alert('Please enter end date');
            }
        }

        if (this.props.formDate != '' && this.props.toDate != '') {
            // this.loadTxnHistory(0, moment(this.props.formDate).format('YYYY-MM-DD'),
            //     moment(this.props.toDate).format('YYYY-MM-DD'), this.state.selectedStatus);
            this.applyTxnHistory();
        }


    }


    errorMessageCall = (error) => {
        this.setState({
            errorMessage: error
        })
    }


    render() {
        var recentTxnLoop = ['test', 'test', 'test', 'test', 'test'];
        return (

            <div>
                <HeaderCommon />
                <Menu />
                <div class="main">


                    <div class="right-side">
                        <div class="container-fluid">


                            <div class="row">
                                <div class="col-12">
                                    <div class="card-b" id="rightdiv">
                                        <div id="recenttxn">
                                            <div class="head">
                                                <h3>Transaction History</h3>
                                                <Link to='/merchant-payout'>
                                                    <button class="back" type="button">Back</button>
                                                </Link>
                                                <Link to='/money-transfer'>
                                                    <button id='moneytransfer' hidden={true}></button>
                                                </Link>

                                                {/* {this.props.exportData == '' &&
													<button class="exprt" type="button" onClick={this.txnHistory}>exprt</button>
												} */}
                                                {this.props.exportData != '' &&
                                                    <CSVLink
                                                        class="exprt"
                                                        data={this.props.exportData}
                                                        asyncOnClick={true}
                                                        onClick={this.resetExportDate}
                                                        filename={"Recharge-" + moment().format('DD-MM-YYYY') + ".csv"}
                                                    >
                                                        Download
                                                    </CSVLink>
                                                }

                                                <div class="dropdown fltr">
                                                    <button type="button" class="filter dropdown-toggle" id="fillist" data-bs-toggle="dropdown" data-bs-auto-close="false" aria-expanded="false">Filter</button>

                                                    <div class="dropdown-menu dropdown-menu-end" aria-labelledby="fillist">
                                                        <form>
                                                            <div class="filters">
                                                                <label for="status">Status:</label>


                                                                <select class="form-select" id="status"
                                                                    aria-label=""
                                                                    onChange={this.statusSelect} required>

                                                                    {this.state.statusList.map(status => (
                                                                        <option value={status.value}
                                                                        >{status.label}</option>
                                                                    ))}

                                                                </select>

                                                            </div>

                                                            <div class="filters">
                                                                <label for="select-state">From Date:</label>
                                                                <input type="date" name="" id=""
                                                                    onChange={this.formDateSelect}
                                                                />
                                                            </div>

                                                            <div class="filters">
                                                                <label for="select-state">To Date:</label>
                                                                <input type="date" name="" id=""
                                                                    onChange={this.toDateSelect} />
                                                            </div>

                                                            <div class="fbtn">
                                                                <button class="dbbtn" type="submit" id="btnClear"
                                                                    onClick={this.submitFilter}>Apply</button>
                                                                <button class="lbbtn" type="reset" id="btnClear" onClick={this.clearAll}>Clear</button>
                                                            </div>
                                                        </form>
                                                    </div>


                                                    <div class="headsearch">
                                                        <div class="input-group">
                                                            <input type="text" class="form-control" onChange={this.enterTxn} placeholder="Search transaction..." />
                                                            <button class="btn search" type="button" id="txnsrch" onClick={this.searchTxn}></button>
                                                            <button
                                                                style={{ background: "#FF8D33", marginLeft: "3px" }}
                                                                class="btn delete"
                                                                // disabled={search.length <= 3}
                                                                type="button"
                                                                onClick={this.clearAll}
                                                            >Clear</button>
                                                        </div>

                                                    </div>

                                                </div>

                                            </div>
                                            <div class="txn-list" id="recntxn">


                                                {
                                                    this.state.payoutHistory != undefined &&
                                                    this.state.payoutHistory != 'error' &&
                                                    this.state.payoutHistory != 'loading' &&
                                                    this.state.payoutHistory.length > 0 &&
                                                    this.state.payoutHistory.map((txnOrder, index) => (

                                                        <div class={txnOrder.status != null &&
                                                            (txnOrder.status == 'FAILED'
                                                                || txnOrder.status == 'INTERNAL_FAILURE'
                                                                || txnOrder.status == 'SUCCESS_TO_FAILED') ?
                                                            "txncard rdbg" : (txnOrder.status == 'PENDING'
                                                                || txnOrder.status == 'ACCEPTED'
                                                                || txnOrder.status == 'PROCESSING'
                                                                || txnOrder.status == 'HUNG'
                                                            ) ? "txncard ylbg" :
                                                                (txnOrder.status == 'AUTO_REVERSED'
                                                                    || txnOrder.status == 'MANUALLY_REVERSED'
                                                                ) ? "txncard ylbg" :
                                                                    txnOrder.status == 'SUCCESS' ? "txncard grbg" :
                                                                        "txncard rdbg"}
                                                            // <div class="txncard white"
                                                            id={"txnhead" + index}>
                                                            <div class="txn-basic" data-bs-toggle="collapse" data-bs-target={"#txn" + index}
                                                                aria-expanded="false" aria-controls={"#txn" + index}>
                                                                <div class="txn-type">
                                                                    <img src={"images/bank-logo.png"} alt="bank" data-toggle="tooltip"
                                                                    // title={txnOrder.transaction.operator.toLowerCase()}
                                                                    />
                                                                    {/* <h5>{this.props.rechargeType.toUpperCase()} - Recharge</h5> */}
                                                                    <h5>PayOut </h5>
                                                                    <p>{txnOrder.transaction != null ?
                                                                        txnOrder.transaction.mobile != null ?
                                                                            txnOrder.transaction.mobile : txnOrder.transaction.customerId != null ?
                                                                                txnOrder.transaction.customerId : 'NA' : 'NA'}</p>
                                                                </div>
                                                                <div class="txn-no">
                                                                    <h6>Order ID: {txnOrder.id != null ?
                                                                        txnOrder.id : 'NA'}</h6>
                                                                    <p> {txnOrder.createdOn != null ?
                                                                        moment(txnOrder.createdOn).format('DD-MM-YYYY HH:mm:ss') : 'NA'}</p>
                                                                </div>
                                                                <div class="txn-amount">
                                                                    <h4>₹ {txnOrder.transaction != null ?
                                                                        txnOrder.transaction.amount != null ?
                                                                            parseFloat(txnOrder.transaction.amount).toFixed(2) : 'NA' : 'NA'}</h4>
                                                                    <p class={txnOrder.status != null ? (txnOrder.status == 'FAILED'
                                                                        || txnOrder.status == 'INTERNAL_FAILURE'
                                                                        || txnOrder.status == 'SUCCESS_TO_FAILED') ? 'failed'
                                                                        : (txnOrder.status == 'PENDING'
                                                                            || txnOrder.status == 'ACCEPTED'
                                                                            || txnOrder.status == 'PROCESSING'
                                                                            || txnOrder.status == 'HUNG'
                                                                        ) ? 'pending'
                                                                            : (txnOrder.status == 'AUTO_REVERSED'
                                                                                || txnOrder.status == 'MANUALLY_REVERSED'
                                                                            ) ? 'pending'
                                                                                : txnOrder.status == 'SUCCESS' ? 'success' :
                                                                                    'pending'

                                                                        : 'pending'}>{txnOrder.status != null &&
                                                                            (txnOrder.status == 'FAILED'
                                                                                || txnOrder.status == 'INTERNAL_FAILURE'
                                                                                || txnOrder.status == 'SUCCESS_TO_FAILED') ?
                                                                            'Failed' : (txnOrder.status == 'PENDING'
                                                                                || txnOrder.status == 'ACCEPTED'
                                                                                || txnOrder.status == 'PROCESSING'
                                                                                || txnOrder.status == 'HUNG'
                                                                            ) ? 'Pending' :
                                                                                (txnOrder.status == 'AUTO_REVERSED'
                                                                                    || txnOrder.status == 'MANUALLY_REVERSED'
                                                                                ) ? 'Reversed' :
                                                                                    txnOrder.status == 'SUCCESS' ? 'Success' :
                                                                                        txnOrder.status.toUpperCase}</p>
                                                                </div>
                                                            </div>

                                                            <div id={"txn" + index} class="accordion-collapse collapse"
                                                                aria-labelledby={"txnhead" + index} data-bs-parent="#recntxn" data-parent="#recntxn">
                                                                <div class="txn-details">
                                                                    <div class="txn-type">
                                                                        <h6>Aadhaar No.: {txnOrder.transaction.customerId.substring(0, 4) + 'XXXXXXXX'}</h6>
                                                                        <p>Mobile No.: {txnOrder.transaction.mobile}</p>
                                                                    </div>
                                                                    <div class="txn-no">
                                                                        <h6>Debited from:</h6>
                                                                        <p>TA - {this.props.agentInfo.mobile}</p>
                                                                    </div>

                                                                    <div class="blnc-amount">
                                                                        <p>TA Balance</p>
                                                                        <h5>₹ NA</h5>
                                                                    </div>
                                                                </div>

                                                                <div class="subtxn">
                                                                    <h4>Sub Transactions</h4>
                                                                    <div class={txnOrder.status == 'SUCCESS' ? "subtxn-success" :
                                                                        (txnOrder.status == 'FAILED'
                                                                            || txnOrder.status == 'INTERNAL_FAILURE'
                                                                            || txnOrder.status == 'SUCCESS_TO_FAILED') ? "subtxn-failed" :
                                                                            (txnOrder.status == 'PENDING'
                                                                                || txnOrder.status == 'ACCEPTED'
                                                                                || txnOrder.status == 'PROCESSING'
                                                                                || txnOrder.status == 'HUNG'
                                                                            ) ? "subtxn-pending" :
                                                                                (txnOrder.status == 'AUTO_REVERSED'
                                                                                    || txnOrder.status == 'MANUALLY_REVERSED'
                                                                                ) ? "subtxn-pending" :
                                                                                    "subtxn-pending"}>
                                                                        <div class="subtxnleft">
                                                                            <div class="subtxntxt">{txnOrder.status == 'SUCCESS' ? "Successful" :
                                                                                (txnOrder.status == 'FAILED'
                                                                                    || txnOrder.status == 'FAIL'
                                                                                    || txnOrder.status == 'INTERNAL_FAILURE'
                                                                                    || txnOrder.status == 'SUCCESS_TO_FAILED') ? "Failed" :
                                                                                    (txnOrder.status == 'PENDING'
                                                                                        || txnOrder.status == 'ACCEPTED'
                                                                                        || txnOrder.status == 'PROCESSING'
                                                                                        || txnOrder.status == 'HUNG'
                                                                                    ) ? "Under Process" :
                                                                                        (txnOrder.status == 'AUTO_REVERSED'
                                                                                            || txnOrder.status == 'MANUALLY_REVERSED'
                                                                                        ) ?
                                                                                            "Reversed" :
                                                                                            txnOrder.status.toUpperCase()}</div>
                                                                            <div class="subtxnid">{txnOrder.id != null ?
                                                                                txnOrder.id : 'NA'}
                                                                                <span> {txnOrder.createdOn != null ?
                                                                                    moment(txnOrder.createdOn).format('DD-MM-YYYY HH:mm:ss') : 'NA'}</span></div>
                                                                        </div>
                                                                        <div class="subamunt">₹{txnOrder.transaction != null ?
                                                                            txnOrder.transaction.amount != null ?
                                                                                parseFloat(txnOrder.transaction.amount).toFixed(2) : 'NA' : 'NA'}</div>

                                                                        {txnOrder.status != 'SUCCESS' &&
                                                                            txnOrder.txnDetails != null &&
                                                                            txnOrder.txnDetails != '' &&
                                                                            txnOrder.txnDetails != undefined &&
                                                                            txnOrder.txnDetails.supplierRsp != null &&
                                                                            txnOrder.txnDetails.supplierRsp != '' &&
                                                                            txnOrder.txnDetails.supplierRsp != undefined &&
                                                                            // <div class="subtxnleft">
                                                                            <div class="subtxnleft">
                                                                                <b>{txnOrder.txnDetails.supplierRsp.toLowerCase().includes("displaymsg") ?
                                                                                    txnOrder.txnDetails.supplierRsp.toLowerCase().substring(txnOrder.txnDetails.supplierRsp.toLowerCase().indexOf("displaymsg"),
                                                                                        txnOrder.txnDetails.supplierRsp.length).replace("displaymsg:", "").replace("displaymsg-", "") :
                                                                                    txnOrder.txnDetails.supplierRsp.toLowerCase()}</b>
                                                                            </div>
                                                                            // </div>

                                                                        }

                                                                    </div>



                                                                    <div class="orderdetail1">
                                                                        <div class="txnhead">Order Details</div>
                                                                        <div class="odramt">
                                                                            <p>Order Amount <span>₹ {txnOrder.txnDetails != null ?
                                                                                txnOrder.txnDetails.amount != null ?
                                                                                    parseFloat(txnOrder.txnDetails.amount).toFixed(2) : 'NA' : 'NA'}</span></p>
                                                                            <p>Surcharge <span>₹ {txnOrder.txnDetails != null ?
                                                                                txnOrder.txnDetails.surcharge != null ?
                                                                                    parseFloat(txnOrder.txnDetails.surcharge).toFixed(2) : '0.00' : '0.00'}</span></p>
                                                                        </div>

                                                                        <div class="ttlamt">
                                                                            <p>Total Amount <span>₹{
                                                                                parseFloat((txnOrder.txnDetails.amount) + (txnOrder.txnDetails != null ? txnOrder.txnDetails.surcharge : 0)).toFixed(2)
                                                                            }</span></p></div>
                                                                    </div>

                                                                    <div class="tnsfrdetail1">
                                                                        <div class="txnhead">Withdrawal Details</div>
                                                                        <div class="odramt">
                                                                            <p>Withdrawal Amount <span>₹ {(txnOrder.status.toLowerCase().includes('fail') == false && txnOrder.transaction != null) ?
                                                                                txnOrder.txnDetails.amount != null ?
                                                                                    parseFloat(txnOrder.txnDetails.amount).toFixed(2) : 'NA' : '0.00'}</span></p>
                                                                            <p>Surcharge <span>₹ {(txnOrder.status.toLowerCase().includes('fail') == false && txnOrder.transaction != null) ?
                                                                                txnOrder.txnDetails.surcharge != null ?
                                                                                    parseFloat(txnOrder.txnDetails.surcharge).toFixed(2) : '0.00' : '0.00'}</span></p>
                                                                        </div>

                                                                        <div class="ttlamt"><p>Total Amount <span>₹ {txnOrder.status.toLowerCase().includes('fail') == false ?
                                                                            parseFloat((txnOrder.txnDetails.amount) + (txnOrder.txnDetails != null ? txnOrder.txnDetails.surcharge : 0)).toFixed(2)
                                                                            : parseFloat(0).toFixed(2)
                                                                        }</span></p>
                                                                        </div>
                                                                    </div>
                                                                    <div class="txn-btn">
                                                                        {/* <button type="button" class="retry" onClick={e => this.moneyTransfer(e, txnOrder)}>Repeat</button> */}
                                                                        {
                                                                            <button type="button" class="print"
                                                                                data-bs-toggle="modal"
                                                                                data-bs-target="#print"
                                                                                onClick={e => this.moDalPrint(e, txnOrder)}>Print</button>
                                                                        }


                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                            </div>

                                            {
                                                this.state.errorMessage == '' &&
                                                this.state.contentLoading == false &&
                                                this.state.payoutHistory.length == 0 &&
                                                <div>
                                                    No records found
                                                </div>
                                            }




                                            {/* {this.state.errorMessage != '' &&
                                                <div class='valid-error'>
                                                    {this.state.errorMessage}
                                                </div>} */}
                                            {
                                                this.state.payoutHistory == undefined &&
                                                <div >
                                                    No Records found
                                                </div>
                                            }
                                            {
                                                this.state.payoutHistory == 'error' &&
                                                <div class='valid-error'>
                                                    Something went wrong,please try later!
                                                </div>
                                            }
                                            {
                                                this.state.payoutHistory.length == 0 &&
                                                <div >
                                                    No Recent Records found
                                                </div>
                                            }
                                            {
                                                this.state.payoutHistory == 'loading' &&
                                                <div >
                                                    Loading transaction history....
                                                </div>
                                            }
                                            {
                                                this.state.errorMessage == '' &&
                                                this.state.contentLoading == true &&
                                                // this.props.txnPaginationResponse!='' &&
                                                recentTxnLoop.map((rctn, index) => (
                                                    <div class="txn-item">
                                                        <div class="txncard">
                                                            <ContentLoader
                                                                width={350}

                                                                height={50}
                                                                speed={1}
                                                                backgroundColor="#f3f3f3"
                                                                foregroundColor="#ecebeb"
                                                                viewBox="0 0 350 50"
                                                            ><rect x="48" y="8" rx="3" ry="3" width="100" height="6" />
                                                                <rect x="48" y="26" rx="3" ry="3" width="40" height="6" />
                                                                <circle cx="20" cy="20" r="20" />
                                                            </ContentLoader>
                                                        </div>
                                                    </div>
                                                )
                                                )
                                            }
                                            {

                                                this.state.contentLoading == false &&
                                                this.state.payoutHistory != undefined &&
                                                this.state.payoutHistory != null &&
                                                this.state.payoutHistory.length > 0 &&
                                                <div class="pager">

                                                    <p>
                                                        {"Showing " + (((this.state.activePage - 1) * 20) + 1) + " to " +
                                                            (this.state.totalElements < (((this.state.activePage - 1) * 20)
                                                                + this.state.payoutHistory.length) ?
                                                                this.state.totalElements :
                                                                (((this.state.activePage - 1) * 20) + this.state.payoutHistory.length))
                                                            + " no records of total " +
                                                            this.state.totalElements}  entries</p>

                                                    <Pagination
                                                        activePage={this.state.activePage}
                                                        itemsCountPerPage={this.state.totalElements / this.state.totalPages}

                                                        totalItemsCount={
                                                            this.state.totalElements}
                                                        pageRangeDisplayed={5}
                                                        onChange={this.handlePageChangeDefault.bind(this)}
                                                        className="pagination"
                                                        linkClass="page-link"
                                                        itemClass="page-item"
                                                    />
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                                <FooterComponet />

                                {/* {this.state.showModal} */}

                                <div class="modal fade" id="print" data-bs-backdrop="static"
                                    data-bs-keyboard="false" tabindex="-1">
                                    <div class="modal-dialog">
                                        <div class="modal-content">
                                            <div class="modal-header modhead">
                                                <h5 class="modal-title">Payout Reciept</h5>
                                                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                            </div>
                                            <div class="modal-body">
                                                <div class="printtable">
                                                    <div class="printlogo">
                                                        <img src={FinxPayLogo} alt="logo" />
                                                    </div>
                                                    <table class="table table-striped table-bordered" border="1" border-collapse>
                                                        <tbody>
                                                            <tr>
                                                                <td>Payment Status:</td>
                                                                <td><strong>{this.state.paymentStatus}</strong></td>
                                                            </tr>
                                                            <tr>
                                                                <td>Transfer Amount:</td>
                                                                <td>₹ {this.state.transferredAmount}</td>
                                                            </tr>
                                                            {/* <tr>
                                                                <td>Surcharge:</td>
                                                                <td>₹ {this.state.surcharge}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Total Amount:</td>
                                                                <td>₹ {parseFloat(this.state.totalAmount).toFixed(2)}</td>
                                                            </tr> */}


                                                            <tr>
                                                                <td>Order Id:</td>
                                                                <td>{this.state.orderId}</td>
                                                            </tr>
                                                            {this.state.benefisciaryMobile != null &&
                                                                this.state.benefisciaryMobile != undefined &&
                                                                this.state.benefisciaryMobile != '' &&
                                                                <tr>
                                                                    <td>Benefisciary Mobile:</td>
                                                                    <td>{this.state.benefisciaryMobile}</td>
                                                                </tr>
                                                            }
                                                            {this.state.benefisciaryName != null &&
                                                                this.state.benefisciaryName != undefined &&
                                                                this.state.benefisciaryName != '' &&
                                                                <tr>
                                                                    <td>Benefisciary Name:</td>
                                                                    <td>{this.state.benefisciaryName}</td>
                                                                </tr>
                                                            }
                                                            {this.state.mobile != null &&
                                                                this.state.mobile != undefined &&
                                                                this.state.mobile != '' &&
                                                                <tr>
                                                                    <td>Mobile:</td>
                                                                    <td>{this.state.mobile}</td>
                                                                </tr>
                                                            }
                                                            {this.state.customerId != null &&
                                                                this.state.customerId != undefined &&
                                                                this.state.customerId != '' &&
                                                                <tr>
                                                                    <td>CustomerId:</td>
                                                                    <td>{this.state.customerId}</td>
                                                                </tr>
                                                            }
                                                            {this.state.paymentTxnId != null &&
                                                                this.state.paymentTxnId != undefined &&
                                                                this.state.paymentTxnId != '' &&
                                                                <tr>
                                                                    <td>Payment Txn ID:</td>
                                                                    <td>{this.state.paymentTxnId}</td>
                                                                </tr>
                                                            }
                                                            <tr>
                                                                <td>Date:</td>
                                                                <td>{this.state.createdOn}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>

                                                    {this.state.txnSubOrder != '' &&

                                                        <table class="table table-bordered">
                                                            <tbody>
                                                                <tr>
                                                                    <td colspan="3">Sub Transactions Details:</td>
                                                                </tr>
                                                                <tr class="table-secondary">
                                                                    <td>Transactions ID</td>
                                                                    <td>Amount</td>
                                                                    <td>Status</td>
                                                                    <td>Payment Ref.</td>
                                                                </tr>

                                                                {this.state.txnSubOrder.map(txRsp => (

                                                                    <tr>
                                                                        <td>{txRsp.id}</td>
                                                                        <td>₹ {parseFloat(txRsp.txnDetails.amount).toFixed(2)}</td>
                                                                        <td>{txRsp.status == 'INIT' ? 'Pending' : txRsp.status.substring(0, 1).toUpperCase() +
                                                                            txRsp.status.substring(1, txRsp.status.length).toLowerCase()}</td>
                                                                        <td>
                                                                            {txRsp.paymentRefId}
                                                                        </td>
                                                                    </tr>
                                                                ))
                                                                }
                                                            </tbody>
                                                        </table>
                                                    }


                                                </div>
                                            </div>
                                            <div class="modal-footer mdftr">
                                                <button type="button" class="btn dbbtn" data-bs-dismiss="modal" onClick={this.printdiv}>Print</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>



                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (
    { errorMessageReduce: { errorMessage, loginErrorMessage },
        miscReduce: { phone, agentInfo, token, clientRole, clientRequesterId, txnHistoryResponse, exportData, totalElementsNo,
            txnPaginationResponse, deviceInfo, rechargeTxnHistory, callBackUrl },
        rechargeReduce: { rechargeType,
            toDate, formDate } }
) => ({
    errorMessage, loginErrorMessage, phone, agentInfo, token, clientRole, clientRequesterId, txnHistoryResponse, exportData,
    totalElementsNo,
    txnPaginationResponse, deviceInfo, rechargeTxnHistory, callBackUrl,
    rechargeType, toDate, formDate
});

export default connect(mapStateToProps, null)(PayoutAllTxn);
